/**
 * English translations for Cyberpass Admin Panel
 */
const en = {
  /* Common */
  "common.loading": "Loading...",
  "common.save": "Save",
  "common.add": "Add",
  "common.archive": "Archive",
  "common.archiveItem": "Archive",
  "common.cancel": "Cancel",
  "common.retry": "Retry",
  "common.confirm": "Confirm",
  "common.editRecord": "Edit Record",
  "common.noData": "No data",
  "common.readOnly": "(read-only)",
  "common.selectPlaceholder": "-- {label} --",
  "common.uploading": "Uploading...",
  "common.replace": "Replace",
  "common.upload": "Upload",
  "common.delete": "Delete",
  "common.pasteFromClipboard": "or paste image from clipboard",
  "common.search": "Search",
  "common.back": "Back",
  "common.byPhone": "By phone",
  "common.byName": "By name",
  "common.byEmail": "By E-mail",
  "common.notFound": "Not found",
  "common.found": "Found",
  "common.minutes": "min",
  "common.hours": "h",
  "common.openInEmployeePanel": "Open in employee panel",
  "common.notSpecified": "Not specified",
  "common.addComputer": "Add Computer",
  "common.yes": "Yes",
  "common.no": "No",
  "common.close": "Close",
  "common.or": "or",
  "common.all": "All",
  "common.none": "None",

  /* Language */
  "language.ru": "Русский",
  "language.en": "English",
  "language.select": "Language",

  /* Auth / Login */
  "auth.signIn": "Sign In",
  "auth.login": "Username",
  "auth.password": "Password",
  "auth.restorePassword": "Restore Password",
  "auth.passwordRecovery": "Password Recovery",
  "auth.telegramUsername": "Telegram Username",
  "auth.loginSuccess": "Successful login",
  "auth.loggingIn": "Logging in",
  "auth.fetchUserFailed": "Failed to fetch user data",
  "auth.incorrectCredentials": "Incorrect username or password",
  "auth.locationNotFound": "Provided location not found or inactive",
  "auth.unexpectedError": "An unexpected error occurred",
  "auth.locationsError": "Failed to fetch available locations",
  "auth.passwordSent": "New password sent to Telegram",
  "auth.userNotFoundInTelegram": "User with this Telegram username not found",

  /* NavBar */
  "nav.registerUser": "User Registration",
  "nav.interactWithUser": "User Interaction",

  /* Admin Sidebar */
  "admin.employeePanel": "Employee Panel",
  "admin.managerPanel": "Manager Panel",
  "admin.scanQr": "Scan\nQR Code",
  "admin.restoreAccess": "Restore Access",
  "admin.recentCustomers": "Recent Customers",
  "admin.logout": "Logout",

  /* Super Admin Sidebar */
  "super.customers": "Customers",
  "super.employees": "Employees",
  "super.packages": "Packages",
  "super.locations": "Locations",
  "super.services": "Services",
  "super.import": "Import",
  "super.calendar": "Calendar",
  "super.media": "Media",
  "super.discounts": "Discounts",
  "super.marketing": "Marketing",
  "super.playtime": "Computers",

  /* QR Scanner */
  "qr.scan": "Scan QR Code",
  "qr.camera": "Camera",
  "qr.manualInput": "Manual",
  "qr.placeholder": "QR Code",
  "qr.userNotFound": "User not found",
  "qr.userFound": "User found",
  "qr.cameraUnavailable": "Camera unavailable",

  /* Restore Access */
  "restore.title": "Restore Access",
  "restore.phoneLabel": "Customer phone number",
  "restore.found": "Found",
  "restore.notFound": "Not Found",
  "restore.name": "Name",
  "restore.email": "Email",
  "restore.balance": "Balance",
  "restore.balanceUnit": "min.",
  "restore.enableEmailNotifications": "Enable balance update emails",
  "restore.confirmWithNotifications": "Confirm and enable notifications",
  "restore.confirm": "Confirm",
  "restore.modalTitle": "Restore Access",
  "restore.modalBody":
    "An email with login notification and backup QR will be sent to the customer's email {email}.",
  "restore.modalHint":
    "If the email is outdated, ask the customer to update it by re-registering.",
  "restore.success": "Access successfully restored",
  "restore.error": "Error restoring access",

  /* Customer Info */
  "customer.phone": "Phone",
  "customer.email": "E-mail",
  "customer.balance": "Balance",
  "customer.debt": "Debt",
  "customer.minutes": "min",
  "customer.hours": "h",
  "customer.birthDate": "Birth Date",
  "customer.vip": "VIP",
  "customer.basic": "Basic",
  "customer.canBecomeVipToday": "can become VIP today!",
  "customer.lastVisit": "Last visit",

  /* Customer History Tab */
  "history.date": "Date",
  "history.employee": "Employee",
  "history.location": "Location",
  "history.minutes": "Minutes",
  "history.amount": "Amount",
  "history.service": "Service",
  "history.event": "Event",

  /* Customer Tabs */
  "customerTab.buyMinutes": "Buy Minutes",
  "customerTab.checkoutMinutes": "Deduct Minutes",
  "customerTab.history": "History",
  "customerTab.discounts": "Discounts",

  /* Page Titles */
  "page.customers": "Customers",
  "page.employees": "Employees",
  "page.packages": "Minutes Packages",
  "page.locations": "Locations",
  "page.services": "Services",
  "page.allowedWallets": "Importable Wallets",
  "page.holidays": "Holiday Calendar",
  "page.media": "Media",
  "page.discounts": "Discounts",
  "page.marketing": "Marketing",
  "page.paperWallets": "Importable Wallets",
  "page.restoreAccess": "Restore Access",
  "page.playtime": "Computers",
  "page.flexibleDiscounts": "Flexible Discounts",

  /* Holidays */
  "holidays.instruction":
    "Enter holidays for each month (one per line, DD.MM format)",
  "holidays.format": "Format",
  "holidays.clear": "Clear",

  /* Page: Add/Edit dialogs */
  "dialog.add": "Add",
  "dialog.addEmployee": "Add Employee",
  "dialog.addPackage": "Add Minutes Package",
  "dialog.addLocation": "Add Location",
  "dialog.addService": "Add Service",
  "dialog.addDiscount": "Add Discount",
  "dialog.addRecord": "Add",
  "dialog.editRecord": "Edit Record",
  "dialog.addHoliday": "Add",
  "dialog.addMedia": "Add",
  "dialog.addAllowedWallet": "Add",
  "dialog.addPaperWallet": "Add Range",
  "dialog.addZone": "Add Zone",
  "dialog.addComputer": "Add Computer",

  /* Table Columns */
  "col.id": "ID",
  "col.firstName": "First Name",
  "col.lastName": "Last Name",
  "col.phone": "Phone",
  "col.email": "E-mail",
  "col.birthDate": "Birth Date",
  "col.minutesBalance": "Minutes Balance",
  "col.debt": "Debt",
  "col.registeredAt": "Registered",
  "col.username": "Username",
  "col.telegram": "Telegram",
  "col.isActive": "Active",
  "col.minutesAmount": "Minutes Amount",
  "col.onlineBonus": "Online Bonus",
  "col.cashBonus": "Cash Bonus",
  "col.vipBonus": "VIP Bonus",
  "col.price": "Price",
  "col.discount": "Discount",
  "col.isInstant": "Instant",
  "col.available": "Available",
  "col.name": "Name",
  "col.address": "Address",
  "col.isLocationActive": "Active",
  "col.coverUrl": "Cover",
  "col.easyweekUuid": "EasyWeek UUID",
  "col.bookingServices": "Booking Services",
  "col.appointmentMaxPlayers": "Max Players (Appt)",
  "col.latitude": "Latitude",
  "col.longitude": "Longitude",
  "col.serviceName": "Service Name",
  "col.serviceActive": "Service Active",
  "col.seats": "Seats",
  "col.location": "Location",
  "col.from": "From",
  "col.to": "To",
  "col.year": "Year",
  "col.renderIndex": "Index",
  "col.description": "Description",
  "col.dayType": "Day Type",
  "col.filePath": "File Path",
  "col.locationId": "Location",
  "col.marketingConsent": "Marketing Consent",
  "col.comment": "Comment",
  "col.amount": "Amount",
  "col.zoneName": "Zone",
  "col.computerNumber": "Computer #",
  "col.apiKey": "API Key",
  "col.status": "Status",
  "col.zoneId": "Zone",

  /* Form Labels */
  "form.marketingConsent": "Marketing Consent",
  "form.comment": "Comment",
  "form.minutesAmount": "Minutes Amount",
  "form.price": "Price",
  "form.discount": "Discount",
  "form.isInstant": "Instant",
  "form.available": "Available",
  "form.name": "Name",
  "form.address": "Address",
  "form.latitude": "Latitude",
  "form.longitude": "Longitude",
  "form.coverUrl": "Cover",
  "form.easyweekUuid": "EasyWeek UUID",
  "form.easyweekLocationUuid": "EasyWeek Location UUID",
  "form.easyweekServiceUuid": "EasyWeek Service UUID",
  "form.bookingServices": "Booking Services",
  "form.appointmentMaxPlayers": "Max Players (Appt)",
  "form.serviceName": "Service Name",
  "form.location": "Location",
  "form.seats": "Seats",
  "form.active": "Active",
  "form.from": "From",
  "form.to": "To",
  "form.year": "Year",
  "form.renderIndex": "Index",
  "form.description": "Description",
  "form.dayType": "Day Type",
  "form.filePath": "File Path",
  "form.locationId": "Location",
  "form.firstName": "First Name",
  "form.lastName": "Last Name",
  "form.phone": "Phone",
  "form.email": "E-mail",
  "form.birthDate": "Birth Date",
  "form.username": "Username",
  "form.telegram": "Telegram",
  "form.zoneName": "Zone Name",
  "form.computerNumber": "Computer Number",
  "form.apiKey": "API Key",
  "form.zoneId": "Zone",
  "form.status": "Status",

  /* Toast messages */
  "toast.recordUpdated": "Record updated",
  "toast.recordCreated": "Record created",
  "toast.recordUpdateFailed": "Failed to update record",
  "toast.recordSaveFailed": "Failed to save record",
  "toast.recordCreateFailed": "Failed to create record",
  "toast.employeeArchived": "Employee archived",
  "toast.employeeArchiveFailed": "Failed to archive employee",
  "toast.packageArchived": "Minutes package archived",
  "toast.packageArchiveFailed": "Failed to archive minutes package",
  "toast.locationArchived": "Location archived",
  "toast.locationArchiveFailed": "Failed to archive location",
  "toast.serviceArchived": "Service archived",
  "toast.serviceArchiveFailed": "Failed to archive service",
  "toast.discountArchived": "Discount archived",
  "toast.discountArchiveFailed": "Failed to archive discount",
  "toast.zoneCreated": "Zone created",
  "toast.zoneUpdated": "Zone updated",
  "toast.zoneArchived": "Zone archived",
  "toast.zoneSaveFailed": "Failed to save zone",
  "toast.zoneArchiveFailed": "Failed to archive zone",
  "toast.computerCreated": "Computer created",
  "toast.computerUpdated": "Computer updated",
  "toast.computerArchived": "Computer archived",
  "toast.computerSaveFailed": "Failed to save computer",
  "toast.computerArchiveFailed": "Failed to archive computer",
  "toast.apiKeyPrefilled": "API key filled from QR code",
  "toast.apiKeyNotFound": "QR code does not contain a computer API key",
  "toast.noZonesForComputer":
    "No zones in this location. Please add a zone first.",
  "toast.selectLocationFirst": "Select a location first",
  "toast.installExpired":
    "Installation QR expired. Run a fresh install to get a new key.",
  "toast.packageFetchFailed": "Failed to fetch minutes packages",
  "toast.customerDataRefreshFailed": "Failed to refresh customer data",
  "toast.walletImported": "Paper wallet successfully imported",
  "toast.walletImportFailed":
    "Wallet verification failed. Check the number or it may have been imported already.",
  "toast.orderCancelled": "Order successfully cancelled",
  "toast.orderCancelFailed": "Failed to cancel order",
  "toast.cancellingOrder": "Cancelling order",
  "toast.transactionIdNotFound": "Failed to find transaction ID",
  "toast.fillAllFields": "Fill in all fields",
  "toast.categoryUpdated": "Category updated",
  "toast.categoryCreated": "Category created",
  "toast.categoryDeleted": "Category deleted",
  "toast.triggerUpdated": "Trigger updated",
  "toast.triggerCreated": "Trigger created",
  "toast.triggerDeleted": "Trigger deleted",
  "toast.enterTitle": "Enter title",
  "toast.enterDescription": "Enter description",
  "toast.enterBody": "Enter notification body",
  "toast.selectCategory": "Select recipient category",
  "toast.notifScheduled": "Notification scheduled",
  "toast.selectTrigger": "Select trigger",
  "toast.notifTriggerCreated": "Trigger notification created",
  "toast.notifDeleted": "Notification deleted",
  "toast.invalidPattern": "Invalid pattern",
  "toast.daysExceedMonth": "Days exceed month boundary",

  /* Confirm Dialog */
  "confirm.archiveTitle": "Confirm Archiving",
  "confirm.deleteCardTitle": "Confirm Card Deletion",
  "confirm.archiveMessage": "Are you sure you want to archive {item}?",
  "confirm.deleteCardMessage":
    "Are you sure you want to delete the passteam card {item}?",
  "confirm.archiveWarning":
    "⚠️ This action cannot be undone. Archiving will hide the item from the active list.",
  "confirm.deleteCardWarning":
    "⚠️ This action cannot be undone. Deleting a card will permanently remove it.",
  "confirm.archiveAction": "Archive",
  "confirm.deleteCardAction": "Delete Card",

  /* Active Online Order */
  "order.paymentInProgress": "Payment in progress",
  "order.statusInfo": "Order Status Info",
  "order.confirmation": "Confirmation",
  "order.payment": "Payment",
  "order.success": "Success",
  "order.minutesAmount": "Minutes Amount",
  "order.cost": "Cost",
  "order.phoneNumber": "Phone Number",
  "order.showQr": "Show QR Code",
  "order.hideQr": "Hide QR Code",
  "order.cancelOrder": "Cancel Order",
  "order.confirmCancel": "The order will be cancelled",
  "order.cancelLoading": "Cancelling order",

  /* Import Paper Wallet */
  "wallet.import": "Import Wallet",
  "wallet.importTitle": "Import Wallet",
  "wallet.walletNumber": "Paper wallet number",
  "wallet.balance": "Balance, min",
  "wallet.importAction": "Import",

  /* Marketing */
  "marketing.allCustomers": "All Customers",
  "marketing.newCustomers": "New (up to 30 days)",
  "marketing.vipCustomers": "VIP (100+ points)",
  "marketing.afterPurchase": "After Purchase",
  "marketing.birthday": "Birthday",
  "marketing.specialOffer": "Special Offer",

  /* History Context Menu */
  "history.cancelTransaction": "Cancel Transaction",
  "history.cancelWarningPurchase":
    "‼️ This is a purchase transaction. Cancelling it will not initiate a refund.\nThe responsible manager must process the refund in Paykeeper before cancelling.",
  "history.cancelWarningPos":
    "‼️ This is a purchase transaction. Cancelling it will not cancel the POS sale.\nThe responsible manager must process the cancellation in Fusion before cancelling.",
  "history.cancelConfirm": "Cancel Transaction",
  "history.cancelSuccess": "Transaction successfully cancelled",
  "history.cancelFailed": "Failed to cancel transaction",

  /* Present Minutes */
  "present.giftMinutes": "Gift Minutes",
  "present.title": "Gift Minutes",

  /* Markdown Editor */
  "markdown.editor": "Editor",
  "markdown.preview": "Preview",
  "markdown.placeholder": "Content in Markdown format...",
  "markdown.noContent": "No content",
  "markdown.previewTitle": "Title",
  "campaign.previewNotifications": "Notifications",

  /* Marketing Dashboard */
  "marketing.title": "Title",
  "marketing.titlePlaceholder": "Special Offer",
  "marketing.description": "Description",
  "marketing.descPlaceholder": "Brief description for notification list",
  "marketing.bodyLabel": "Notification Body (Markdown)",
  "marketing.schedule": "By Schedule",
  "marketing.trigger": "By Trigger",
  "marketing.category": "Recipient Category",
  "marketing.date": "Date",
  "marketing.time": "Time",
  "marketing.repeat": "Repeat",
  "marketing.createNotif": "Create Notification",
  "marketing.scheduledNotifs": "Scheduled Notifications",
  "marketing.editCategory": "Edit Category",
  "marketing.newCategory": "New Category",
  "marketing.name": "Name",
  "marketing.sqlQuery": "SQL Query",
  "marketing.deleteNotif": "Delete Notification",
  "marketing.confirmDeleteNotif": "Delete notification «{title}»?",
  "marketing.editTrigger": "Edit Trigger",
  "marketing.newTrigger": "New Trigger",
  "marketing.triggerEnabled": "Trigger Active",
  "marketing.type": "Type",
  "marketing.recipients": "Recipients",
  "marketing.status": "Status",
  "marketing.newNotification": "New Notification",

  /* Campaign dashboard */
  "campaign.count": "Campaigns ({count})",
  "campaign.create": "+ Create",
  "campaign.name": "Name",
  "campaign.namePlaceholder": "e.g. Birthday VIP",
  "campaign.nameRequired": "Enter a campaign name",
  "campaign.nameRequiredHint":
    "Required — it is how the campaign is told apart in the list and in the log.",
  "campaign.triggerType": "Trigger type",
  "campaign.createBtn": "Create campaign",
  "campaign.createTitle": "New campaign",
  "campaign.createMenuCampaign":
    "A trigger, its push text, its segment and its schedule",
  "campaign.createMenuSegment":
    "The query that produces the audience for a segment",
  "campaign.discardChanges":
    "The campaign settings have unsaved changes. Close anyway?",
  "campaign.editTitle": "Campaign: {name}",
  "campaign.editBtn": "Edit",
  "campaign.segmentsBtn": "Segments",
  "campaign.segmentMenuTitle": "New segment",
  "campaign.scheduleRequired":
    '"{trigger}" only runs on a schedule — set it in the Schedule (cron) field. Without one the campaign can never fire.',
  "campaign.campaignFallback": "Campaign #{id}",
  "campaign.viewLog": "View Log",
  "campaign.close": "Close",
  "campaign.log": "Send log",
  "campaign.noCampaigns": 'No campaigns yet. Click "+ Create" to add one.',
  "campaign.colStatus": "Status",
  "campaign.colName": "Name",
  "campaign.colType": "Type",
  "campaign.launch": "Launch",
  "campaign.run": "Run",
  "campaign.test": "Test",
  "campaign.delete": "Delete campaign",
  "campaign.selectTrigger": "Select a trigger type",
  "campaign.loadingFields": "Loading fields...",
  "campaign.noNotifications": "No notifications sent yet.",
  "campaign.colCustomer": "Customer",
  "campaign.colPhone": "Phone",
  "campaign.colSentAt": "Sent at",
  "campaign.colVariant": "Variant",
  "campaign.confirmDeleteTitle": "Delete campaign",
  "campaign.confirmDeleteMessage":
    'Delete campaign "{item}"? This also removes its send log and snapshots.',
  "campaign.toastCreated": "Campaign created",
  "campaign.toastUpdated": "Campaign updated",
  "campaign.toastDeleted": "Campaign deleted",
  "campaign.toastRunResult": "Sent {sent} / {candidates} pushes",
  "campaign.toastTestResult": "Test push sent to {name}",
  "campaign.toastTestFailed": "Failed to send test push",
  "campaign.testDialogTitle": "Test campaign",
  "campaign.testDialogDesc": "Send a test push to a customer by phone number.",
  "campaign.testDialogPhone": "Phone number",
  "campaign.testDialogPhonePlaceholder": "+79001234567",
  "campaign.testDialogSend": "Send test",
  "campaign.testDialogCancel": "Cancel",
  "campaign.testDialogNotFound": "Customer not found",
  "campaign.toastCreateFailed": "Failed to create campaign",
  "campaign.toastUpdateFailed": "Failed to update campaign",
  "campaign.toastToggleFailed": "Failed to toggle campaign",
  "campaign.toastRunFailed": "Failed to run campaign",
  "campaign.toastRunSuccess": "Campaign run started",
  "campaign.stats": "Stats",
  "campaign.statCandidates": "Next run (candidates)",
  "campaign.statSent": "Already sent",
  "campaign.statFailed": "Failed",
  "campaign.toastDeleteFailed": "Failed to delete campaign",
  "campaign.toastLogFailed": "Failed to load log",
  "campaign.toastLoadFailed": "Failed to load campaigns",
  "campaign.placeholders": "{placeholders}",
  "campaign.placeholdersAvailable": "Available placeholders:",
  "campaign.customSegments": "Custom segments",
  "campaign.segmentName": "Name",
  "campaign.segmentQuery": "Segment query (SQL)",
  "campaign.segmentQueryHint":
    "One SELECT, one integer column named customer_id. It runs read-only.",
  "campaign.segmentQueryRequired": "Write the segment query first",
  "campaign.segmentPreview": "Preview",
  "campaign.segmentPreviewing": "Checking…",
  "campaign.segmentPreviewFailed": "Could not check the query",
  "campaign.segmentPreviewStale":
    "The query changed — preview it again to see the current audience.",
  "campaign.segmentPreviewTotal": "Audience: {total} customers",
  "campaign.segmentPreviewUnknownTotal":
    "The first customers are shown; the total took too long to count.",
  "campaign.segmentPreviewEmpty": "The query matches no customers",
  "campaign.segmentPreviewName": "Name",
  "campaign.segmentPreviewPhone": "Phone",
  "campaign.segmentPreviewBalance": "Balance",
  "campaign.segmentAdd": "Add segment",
  "campaign.segmentEdit": "Edit",
  "campaign.segmentEditTitle": "Edit segment",
  "campaign.segmentSave": "Save query",
  "campaign.segmentCancelEdit": "Cancel edit",
  "campaign.segmentUpdated": "Segment query updated",
  "campaign.segmentUpdateFailed": "Failed to update segment",
  "campaign.segmentNameImmutable":
    "The name cannot change: campaigns select the segment by it. Create a new segment and delete this one instead.",
  "campaign.segmentUsedBy": "Used by campaigns: {campaigns}",
  "campaign.segmentUnused": "Not selected by any campaign yet",
  "campaign.segmentUsageIntro":
    "A segment is the query that produces a campaign's audience. The list below names the campaigns that select it: changing or deleting the query changes the audience of exactly those campaigns.",
  "campaign.segmentDelete": "Delete segment",
  "campaign.segmentCreated": "Segment created",
  "campaign.segmentDeleted": "Segment deleted",
  "campaign.segmentCreateFailed": "Failed to create segment",
  "campaign.segmentDeleteFailed": "Failed to delete segment",
  "campaign.segmentNameRequired": "Segment name is required",
  "campaign.noCustomSegments": "No custom segments yet",
  "campaign.segmentGlobal": "global",
  "campaign.segmentScopeGlobal":
    "Saved as a global segment — available to every campaign.",
  "campaign.segmentScopeCampaign": "Saved for this campaign only.",
  "campaign.segmentHelp": "How custom segments work",
  "campaign.segmentHelpIntro":
    "A custom segment is the query that produces its audience. It is materialised into the snapshot alongside the built-in segments, then selectable as “Segment name in snapshot”.",
  "campaign.segmentHelpContractTitle": "The contract:",
  "campaign.segmentHelpContractNote":
    "A single SELECT (a WITH ... SELECT is fine) returning exactly one integer column named customer_id. Anything that writes, or a second statement behind a ';', is refused, and the query always runs in a read-only transaction with a time limit. Press Preview to see the first ten customers before saving.",
  "campaign.copySql": "Copy SQL",
  "campaign.sqlCopied": "SQL copied to clipboard",
  "campaign.copyingSql": "Copying SQL…",
  "campaign.sqlCopyFailed": "Failed to copy SQL",

  /* Campaign run control */
  "campaign.runProgress": "Send progress",
  "campaign.stop": "Stop",
  "campaign.stopping": "Stopping…",
  "campaign.toastRunStarted": "Campaign run started",
  "campaign.toastStopRequested": "Stop requested",
  "campaign.toastStopFailed": "Failed to stop campaign",
  "campaign.runError": "Run error: {error}",
  "campaign.runFailedHint":
    "Only customers whose device actually accepted the push count as sent.",
  "campaign.runState.running": "Sending — {sent} delivered of {total}",
  "campaign.runState.stopping":
    "Stop requested — finishing the current recipient, {sent} delivered of {total}",
  "campaign.runState.completed":
    "Finished — {sent} delivered of {total}, {failed} failed",
  "campaign.runState.stopped":
    "Stopped — {sent} delivered of {total}, {failed} failed",
  "campaign.runState.failed": "Run failed — {by}",
  "campaign.runState.idle": "Idle",
  "campaign.runStateShort.running": "sending…",
  "campaign.runStateShort.stopping": "stopping…",

  /* Send log */
  "campaign.logRange": "{from}–{to} of {total}",
  "campaign.logPrev": "Newer",
  "campaign.logNext": "Older",

  /* Test send */
  "campaign.toastTestNotDelivered": "Test push for {name} reached no device",

  /* Cron Picker */
  "cron.label": "Schedule (cron)",
  "cron.noSchedule": "No schedule — manual run only",
  "cron.preview": "Schedule",
  "cron.minute": "Min",
  "cron.hour": "Hour",
  "cron.day": "Day",
  "cron.month": "Month",
  "cron.weekday": "Weekday",
  "cron.preset.disabled": "— Manual only (no schedule)",
  "cron.preset.daily10am": "Every day at 10:00",
  "cron.preset.daily9am": "Every day at 09:00",
  "cron.preset.weeklyMonday": "Every Monday at 10:00",
  "cron.preset.monthly1st": "1st of each month at 10:00",
  "cron.preset.custom": "Custom schedule...",
  "cron.desc.manualOnly": "Manual run only",
  "cron.desc.dailyAt": "Daily at {time}",
  "cron.desc.weeklyAt": "Every {day} at {time}",
  "cron.desc.monthlyAt": "{day}th of each month at {time}",
  "cron.desc.everyNMinutes": "Every {n} minutes",
  "cron.desc.everyNHours": "Every {n} hours",
  "cron.weekdayNames.sun": "Sun",
  "cron.weekdayNames.mon": "Mon",
  "cron.weekdayNames.tue": "Tue",
  "cron.weekdayNames.wed": "Wed",
  "cron.weekdayNames.thu": "Thu",
  "cron.weekdayNames.fri": "Fri",
  "cron.weekdayNames.sat": "Sat",

  /* Repeat Labels */
  "repeat.once": "Once",
  "repeat.daily": "Daily",
  "repeat.weekly": "Weekly",
  "repeat.monthly": "Monthly",

  /* Status Labels */
  "status.scheduled": "Scheduled",
  "status.sent": "Sent",

  /* Common - additional */
  "common.open": "Open",
  "common.rename": "Rename",
  "common.import": "Import",

  /* Table Row */
  "tableRow.package": "minutes package",
  "tableRow.unknown": "unknown",
  "tableRow.cardOfCustomer": "passteam card of customer",
  "tableRow.element": "item",

  /* Confirm - additional */
  "confirm.deleteFile": "Delete file «{fileName}»?",
  "confirm.archiveMessagePrefix": "Are you sure you want to",

  /* Checkout Minutes */
  "checkout.info": "Number of minutes spent – any number can be entered",
  "checkout.confirmTitle": "Confirm minutes deduction",
  "checkout.willBeDeducted": "Will be deducted",
  "checkout.customerWillHave": "Customer will have",
  "checkout.service": "Service",
  "checkout.insufficientBalance1": "Insufficient balance:",
  "checkout.insufficientBalance2": "Open package purchase menu with discounts?",

  /* Payment Status */
  "payment.success": "Payment successful",
  "payment.failure": "Oops, something went wrong",
  "payment.minutesCredited":
    "Minutes credited to your balance and available in apps",
  "payment.retry": "Please try again",
  "payment.openInWallet": "Open in wallet",

  /* Online Order Page */
  "orderPage.wrongRequest": "Wrong request",
  "orderPage.title": "Your order",
  "orderPage.instruction":
    "Please check the information and proceed to payment",
  "orderPage.agreement":
    "By clicking the pay button you confirm the order and agree to the terms of service",
  "orderPage.pay": "Pay",
  "orderPage.orderCancelled": "order cancelled",
  "orderPage.payError":
    "Payment could not be started. The order may have expired or been cancelled.",
  "orderPage.orderExpired":
    "This order has expired or was cancelled. Please contact the staff for a new order.",

  /* Media Display */
  "media.scanQr": "Scan QR code",
  "media.toConfirmOrder": "to confirm order",
  "media.continueOnDevice": "Continue on your device",

  /* Registration */
  "registration.userExists": "User with this phone number already exists",
  "registration.firstname": "First name",
  "registration.firstnamePlaceholder": "John",
  "registration.lastname": "Last name",
  "registration.lastnamePlaceholder": "Smith",
  "registration.phone": "Phone",
  "registration.telegram": "Telegram username",
  "registration.confirmTitle": "Confirm registration",

  /* Import Paper Wallet - buttons & labels */
  "importPaperWallet.button": "Import wallet",
  "importPaperWallet.title": "Import wallet",
  "importPaperWallet.walletNumber": "Paper wallet number",
  "importPaperWallet.balance": "Balance, min",
  "importPaperWallet.selectFile": "Select a file to import",
  "importPaperWallet.unknownError": "Unknown error",
  "importPaperWallet.invalidFormat": "Invalid format",
  "importPaperWallet.tryAgain": "Try again",

  /* Choose Package */
  "choosePackage.oneDiscountOnly": "Can only select one discounted package",
  "choosePackage.selectAtLeastOne": "Select at least one package",
  "choosePackage.calcFailed": "Failed to calculate order",

  /* File Manager - additional */
  "fileManager.loadError": "Failed to load file list",
  "fileManager.manageFiles": "Manage Files",
  "fileManager.showTable": "Show Table",
  "fileManager.uploadSuccess": "File uploaded successfully",
  "fileManager.uploadError": "Failed to upload file",
  "fileManager.deleteSuccess": "File deleted",
  "fileManager.deleteError": "Failed to delete file",
  "fileManager.renameSuccess": "File renamed",
  "fileManager.renameError": "Failed to rename file",
  "fileManager.filesUploaded": "Files uploaded",
  "fileManager.uploadFilesError": "Failed to upload files",

  /* Media Manager */
  "mediaManager.uploadTitle": "Upload files",
  "mediaManager.files": "Files",
  "mediaManager.noFiles": "No uploaded files",

  /* Toast - additional */
  "toast.selectService": "Select one of the services",
  "toast.debtCheckoutProhibited": "Cannot deduct minutes due to debt",
  "toast.minutesDeducted": "Minutes successfully deducted",
  "toast.insufficientFunds": "Insufficient funds",
  "toast.minutesDeductionFailed": "Failed to deduct minutes",
  "toast.servicesLoadError": "Services load error",
  "toast.minutesCredited": "Minutes successfully credited",
  "toast.minutesCreditFailed": "Failed to credit minutes",
  "toast.orderCreated": "Order successfully created",
  "toast.orderCreateFailed": "Failed to create order",
  "toast.debtCheckoutProhibited2":
    "Cannot deduct minutes while customer has debt",
  "toast.paperWalletImported": "Paper wallet imported successfully",
  "toast.paperWalletVerifyFailed":
    "Wallet verification failed. Check the number or it may already be imported.",
  "toast.connectionLost": "Connection to server lost. Refresh the page.",
  "toast.subscriptionFailed": "Failed to subscribe to updates",
  "toast.minutesPresented": "Minutes successfully gifted",
  "toast.enterPhoneOrSelectUser": "Enter phone number or select existing user",
  "toast.packagesLoadError": "Failed to fetch packages from server",
  "toast.failedToUpdateCustomer": "Failed to update customer data",

  /* Present Minutes */
  "presentMinutes.button": "Gift minutes",
  "presentMinutes.title": "Gift minutes",
  "presentMinutes.userFound": "User found. Balance",
  "presentMinutes.userNotFound": "User not in the system yet",
  "presentMinutes.packagesForGift": "Minutes gift packages",
  "presentMinutes.confirmTitle": "Confirm gift of minutes",
  "presentMinutes.willBeAdded": "Will be added",
  "presentMinutes.for": "For",
  "presentMinutes.customerWillHave": "Customer will have on balance",

  /* Common - general */
  "common.value": "value",
  "common.until": "until",
  "common.vip": "VIP",
  "common.basic": "Basic",
  "common.canBecomeVipToday": "can become VIP today!",

  /* Auth */
  "auth.incorrectLoginPassword": "Incorrect username or password",
  "auth.locationDeleted": "Provided location not found or inactive",

  /* Nav */
  "nav.restoreAccess": "Restore Access",

  /* Buy Minutes */
  "buyMinutes.for": "For",
  "buyMinutes.expectedBalance": "Customer balance will be",
  "buyMinutes.availableBonuses": "Available bonuses by payment method:",
  "buyMinutes.onlinePayment": "When paying online",
  "buyMinutes.cashPayment": "When paying in cash",
  "buyMinutes.payCash": "Pay in cash",
  "buyMinutes.payOnline": "Pay online",
  "buyMinutes.payPos": "Pay via POS",
  "buyMinutes.splitPaymentFusion": "Split Payment Fusion",
  "buyMinutes.selectFusionMethod": "Select Fusion Payment Method",
  "buyMinutes.fusionInfoText":
    "When paying the order in cash or online at the previous stage, the customer will receive bonus time – be sure to inform them about it.",
  "buyMinutes.pay": "Pay",
  "buyMinutes.selectPaymentMethod": "Select payment method",
  "buyMinutes.sumMismatch": "Sum mismatch",
  "buyMinutes.of": "of",
  "buyMinutes.splitPayment": "Split payment",

  /* Payment Types (Fusion POS) */
  "paymentType.cash": "Cash",
  "paymentType.card": "Card",
  "paymentType.sber": "Sber",
  "paymentType.robokassa": "Robokassa",
  "paymentType.certificate": "Certificate",
  "paymentType.bank_account": "Bank Account",
  "paymentType.cyberpass_qr": "QR CyberPass",

  /* Buy Minutes */
  "buyMinutes.heading": "Minutes packages for purchase",
  "buyMinutes.confirmTitle": "Confirm purchase",
  "buyMinutes.vipBonus": "VIP bonus",
  "buyMinutes.willBeAdded": "Will be added",

  /* Flexible Discount */
  "flexibleDiscount.autoDiscount": "Auto Discount",

  /* Playtime */
  "playtime.zones": "Zones",
  "playtime.computers": "Computers",
  "playtime.zone": "Zone",
  "playtime.computer": "Computer",
  "computer.scanKey": "Scan computer API key",
  "computer.closeScanner": "Close",
  "computer.needNewZone": "Need a new zone, tap here",
  "computer.selectLocationHint": "Select a location first, then create a zone",
  "computer.installExpiredWarning":
    "This installation QR expired — the 15 minute window has passed. Scan a new QR from a fresh install to save this PC.",
};

export default en;
